import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { foreignBusinessVenturesAddressNameFields } from 'constants/enums/people';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { ForeignBusinessVenturesModel } from './types';
import { foreignBusinessVenturesItemValidator } from './validators/item';

const foreignBusinessVenturesValidator: ValidateJSModel<ForeignBusinessVenturesModel> = {
  HasForeignVentures: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes, attributeName, options) => {
    if (attributes?.HasForeignVentures?.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, foreignBusinessVenturesAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }
      return {
        presence: true,
        ...additionalValidation,
        accordion: { validator: foreignBusinessVenturesItemValidator },
      };
    }

    return {};
  },
};
export default foreignBusinessVenturesValidator;
